import { createContext, useState, useContext } from 'react';

export const FarolContext = createContext();

export const FarolProvider = ({ children }) => {
    
    const [ updateFarolCards,                setupdateFarolCards ] = useState(false);

    //The Filters

    const [ selectedDateScenario,            setSelectedDateScenario  ] = useState(null);
    const [ selectedPublicationId,           setSelectedPublicationId ] = useState(null);

    const handleUpdateFarolCards = () => setupdateFarolCards(!updateFarolCards)

   //#region FarolTerminalModal

    const [ selectedFarolTerminal,          setSelectedFarolTerminal      ] = useState(null);
    const [ isFarolTerminalModalOpen,       setFarolTerminalModalOpen     ] = useState(false);

    const handleFarolTerminalModalOpen  = () => setFarolTerminalModalOpen(true)
    const handleFarolTerminalModalClose = () => setFarolTerminalModalOpen(false)

    //#endregion

    //#region FarolTextModal
    const [ isFarolTextModalOpen, setFarolTextModalOpen ] = useState(false);

    const handleFarolTextModalOpen  = () => setFarolTextModalOpen(true)
    const handleFarolTextModalClose = () => setFarolTextModalOpen(false)
    //#endregion

    //#region FarolModal
    const [ isFarolModalOpen, setFarolModalOpen ] = useState(false);
    const [ selectedFarol,    setSelectedFarol  ] = useState(null);

    const handleFarolModalOpen  = () => setFarolModalOpen(true)
    const handleFarolModalClose = () => setFarolModalOpen(false)

    //#endregion

    //#region Cards layout ('lado-a-lado' | 'empilhado'), lembrado no navegador
    const CARDS_LAYOUT_KEY = 'farolCardsLayout'

    const [ cardsLayout, setCardsLayout ] = useState(() => {
        try {
            return localStorage.getItem(CARDS_LAYOUT_KEY) === 'empilhado' ? 'empilhado' : 'lado-a-lado'
        } catch {
            return 'lado-a-lado'
        }
    });

    const toggleCardsLayout = () => {
        const nextLayout = cardsLayout === 'empilhado' ? 'lado-a-lado' : 'empilhado'
        setCardsLayout(nextLayout)
        try { localStorage.setItem(CARDS_LAYOUT_KEY, nextLayout) } catch {}
    }
    //#endregion

    const value = {

        //Cards layout
        cardsLayout, toggleCardsLayout,

        //FarolModal
        isFarolModalOpen,
        handleFarolModalOpen, handleFarolModalClose,
        
        selectedFarol,
        setSelectedFarol,
  
        //FarolTerminalModal
        isFarolTerminalModalOpen,
        selectedFarolTerminal,          setSelectedFarolTerminal,
        handleFarolTerminalModalOpen,   handleFarolTerminalModalClose,

        //PublicationTextModal
        isFarolTextModalOpen,
        handleFarolTextModalOpen, handleFarolTextModalClose,
        
        //table data
        handleUpdateFarolCards,     
        updateFarolCards,

        //Scenarios
        selectedDateScenario, setSelectedDateScenario,
        selectedPublicationId, setSelectedPublicationId 

    }

    return (
        <FarolContext.Provider value={value}>
            {children}
        </FarolContext.Provider>
    )
}

// Custom hook to use the Farol context
export const useFarol = () => {
    const context = useContext(FarolContext)
    if (context === undefined) {
        throw new Error('useFarol must be used within a FarolProvider')
    }
    return context
}
